import { EnhancedStore, configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import siteConfigReducer, { SiteConfigState } from './features/siteConfig';
import docsDataReducer, { DocsDataState } from './features/docsData';
import docsMenuReducer, { DocsMenuState } from './features/docsMenu';
import playgroundReducer, { PlaygroundState } from './features/playground';

export interface DocsPortalStore {
  siteConfig: SiteConfigState;
  docsData: DocsDataState;
  docsMenu: DocsMenuState;
  playground: PlaygroundState;
}

export const docsStore = createDocsStore();

export type AppDispatch = typeof docsStore.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();

export function createDocsStore(
  preloadedState?: Partial<DocsPortalStore>,
): EnhancedStore<DocsPortalStore> {
  return configureStore({
    reducer: {
      siteConfig: siteConfigReducer,
      docsData: docsDataReducer,
      docsMenu: docsMenuReducer,
      playground: playgroundReducer,
    },
    devTools: process.env.NODE_ENV !== 'production',
    preloadedState,
  });
}
